import { Trash, UploadSimple, DownloadSimple } from "@phosphor-icons/react";

export function MasterToolbar({ testPrefix, importer, importHint, importing, fileRef,
  onTemplate, onImportFile, showBulkDelete, selectedCount, onBulkDelete }) {
  return (
    <>
      {importer && (
        <>
          <button data-testid={`${testPrefix}-template-button`} onClick={onTemplate}
            title="Download a sample Excel in the correct format"
            className="flex items-center gap-1.5 rounded-md border border-slate-300 px-3 py-1.5 text-xs font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-100">
            <DownloadSimple size={13} weight="bold" /> Template
          </button>
          <input ref={fileRef} type="file" accept=".xlsx" className="hidden"
            data-testid={`${testPrefix}-import-input`} onChange={onImportFile} />
          <button data-testid={`${testPrefix}-import-button`} onClick={() => fileRef.current?.click()} disabled={importing}
            title={importHint || "Excel with names in the first column (one per row)"}
            className="flex items-center gap-1.5 rounded-md border border-slate-300 px-3 py-1.5 text-xs font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-100 disabled:opacity-60">
            <UploadSimple size={13} weight="bold" /> {importing ? "Importing…" : "Import Excel"}
          </button>
        </>
      )}
      {showBulkDelete && (
        <button data-testid={`${testPrefix}-bulk-delete-button`} onClick={onBulkDelete}
          className="flex items-center gap-1.5 rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white transition-colors duration-150 hover:bg-red-700">
          <Trash size={13} weight="bold" /> Delete selected ({selectedCount})
        </button>
      )}
    </>
  );
}
